import React from 'react';

import connect from 'components/lib/connect';
import ReportChannel from 'models/reports/report_channel';
import AgentPerformanceTable from 'components/reporting/report/lib/agent_performance_table';
import BasicAgentReport from 'components/reporting/report/agent_report';
import PropTypes from 'prop-types';

function AgentReportWrapper({ routingGroupIds, reportChannel, windowWidth }) {
  if ((reportChannel === ReportChannel.ALL || !reportChannel) && routingGroupIds.length === 0) {
    return <AgentPerformanceTable />;
  }

  return <BasicAgentReport channel={reportChannel} windowWidth={windowWidth} />;
}

AgentReportWrapper.propTypes = {
  routingGroupIds: PropTypes.array,
  reportChannel: PropTypes.string,
  windowWidth: PropTypes.number,
};

function mapStateToProps({ getProvider }) {
  const currentLocation = getProvider('currentLocation').get();
  const reportChannel = currentLocation.getChannel();
  const routingGroupIds = currentLocation.getRoutingGroupIds();

  return {
    reportChannel,
    routingGroupIds,
  };
}

export default connect(mapStateToProps)(AgentReportWrapper);
